export const GET_DASHBOARD_WIDGETS = ({ id }) => {
  return {
    url: `/api/dashboards/${id}`,
    headers: {
      'Access-Control-Allow-Origin': '*'
    }
  };
};

export const GET_CANNED_DASHBOARD_WIDGETS = ({ masterObjectId, id }) => {
  return {
    url: `/api/Dashboards/canned/${masterObjectId}/${id}`
  };
};

export const RESET_CANNED_DASHBOARD_SET = ({ masterObjectId }) => {
  return {
    url: `/api/Dashboards/object/reset/${masterObjectId}`,
    method: 'post'
  };
};

export const SAVE_RECENT_DASHBOARD = (
  data) => {
  return {
    url: `/api/Dashboards/save-recent`,
    method: 'post',
    data
  };
};

export const GET_RECENT_DASHBOARDS = () => {
  return {
    url: `/api/Dashboards/recent-dashboards`
  };
};

export const GET_COMMON_USED_BENCHMARKS = () => {
  return {
    url: `/api/Lookups/common-used-benchmarks`
  };
};

export const EXAMPLE_PUT_REQUEST = ({
  isTitleDisplayed,
  isDateDisplayed,
  isLegendDisplayed,
  isChartTooltipDisplayed,
  title,
  startDate,
  endDate,
  dateRangeType,
  id,
  dateRangeTypeId,
  masterObjectId,
  masterObjectTypeId,
  dateMatchType,
  tableColumnsSettings
}) => {
  return {
    url: `/api/charts/${id}`,
    method: 'put',
    data: {
      isTitleDisplayed,
      isDateDisplayed,
      isLegendDisplayed,
      isChartTooltipDisplayed,
      title,
      startDate,
      endDate,
      dateRangeType,
      dateRangeTypeId,
      masterObjectId,
      masterObjectTypeId,
      dateMatchType,
      tableColumnsSettings
    }
  };
};

export const UPDATE_WIDGET_DATE_SETTINGS = ({
  id,
  widgetType = 1,
  startDate,
  endDate,
  dateRangeTypeId,
  dateMatchType,
  dashboardMasterObjectId,
  dashboardMasterObjectTypeId,
  dashboardObjectTypeDetailId,
  customDateRangeMatchType
}) => {
  return {
    url: `api/Settings/date`,
    method: 'put',
    data: {
      id,
      widgetType,
      startDate,
      endDate,
      dateRangeTypeId,
      dateMatchType,
      customDateRangeMatchType,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId
    }
  };
};

export const UPDATE_WIDGET_FILTERS_SETTINGS = ({
  id,
  widgetType = 1,
  startDate,
  endDate,
  dateRangeTypeId,
  dateMatchType,
  dashboardMasterObjectId,
  dashboardMasterObjectTypeId,
  dashboardObjectTypeDetailId,
  customDateRangeMatchType
}) => {
  return {
    url: `api/Settings/date`,
    method: 'put',
    data: {
      id,
      widgetType,
      startDate,
      endDate,
      dateRangeTypeId,
      dateMatchType,
      customDateRangeMatchType,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId
    }
  };
};

export const UPDATE_WIDGET_MAIN_SETTINGS = ({
  id,
  widgetType = 1,
  title,
  description,
  masterObjectId,
  masterObjectTypeId,
  dashboardMasterObjectId,
  dashboardMasterObjectTypeId,
  dashboardObjectTypeDetailId,
  benchmarks,
  timeSeriesSetId = null
}) => {
  return {
    url: 'api/settings/main',
    method: 'put',
    data: {
      id,
      widgetType,
      title,
      description,
      masterObjectId,
      masterObjectTypeId,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId,
      benchmarks,
      timeSeriesSetId
    }
  };
};

export const UPDATE_WIDGET_MORE_OPTIONS = ({
  id,
  widgetType = 1,
  isTitleDisplayed,
  isLegendDisplayed,
  isDateDisplayed,
  isChartTooltipDisplayed,
  dashboardMasterObjectId,
  dashboardMasterObjectTypeId,
  dashboardObjectTypeDetailId
}) => {
  return {
    url: '/api/settings/more-options',
    method: 'put',
    data: {
      id,
      widgetType,
      isTitleDisplayed,
      isLegendDisplayed,
      isDateDisplayed,
      isChartTooltipDisplayed,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId
    }
  };
};

export const UPDATE_WIDGET_ATTRIBUTES = ({
  id,
  widgetType = 1,
  attributeIds,
  dashboardMasterObjectId,
  dashboardMasterObjectTypeId,
  dashboardObjectTypeDetailId
}) => {
  return {
    url: '/api/settings/attributes',
    method: 'put',
    data: {
      id,
      widgetType,
      attributeIds,
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId
    }
  };
};

export const UPDATE_USER_ROUTE = route => {
  return {
    url: '/api/settings/homepage',
    method: 'post',
    data: { route }
  };
};

export const GET_FC_WIDGET_DATA = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/charts/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/charts/${id}?masterObjectId=${masterObjectId}`
  }
};

export const GET_DEFAULT_MASTER_OBJECT_BENCHMARKS = ({ masterObjectId }) => {
  return {
    url: `/api/Lookups/object-benchmarks/${masterObjectId}`
  };
};

export const GET_MONTHLY_CORRELATION_DATA = ({ id }) => {
  return {
    url: `/api/Charts/holding-monthly-correlation/${id}`
  };
};
export const GET_STRATEGY_EXPOSURE_DATA = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/charts/strategy/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/charts/strategy/${id}?masterObjectId=${masterObjectId}`
  };
};

// export const GET_STRATEGY_EXPOSURE_DATA = ({ id, masterObjectId }) => {
//   return {
//     url: `/api/charts/strategy-exposure/${id}?masterObjectId=${masterObjectId}`
//   };
// };

export const GET_SUB_STRATEGY_EXPOSURE_DATA = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/charts/sub-strategy-exposure/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/charts/sub-strategy-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_GEO_EXPOSURE_DATA = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/Charts/geo-exposure/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/Charts/geo-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_MAIN_EXPOSURE_DATA = ({ id, masterObjectId, returnData }) => {
  return {
    url: `/api/Charts/main-exposure/${id}?returnData=${returnData}&masterObjectId=${masterObjectId}`
  };
};

export const GET_TABLE_WIDGET_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/tables/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_GENERIC_CHART_WIDGET_DATA = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/charts/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    }
  }
  return {
    url: `/api/charts/${id}?masterObjectId=${masterObjectId}`
  }
};

export const GET_ANNUAL_STACKED_COLUMN_CHARTS = ({ id, masterObjectId, returnData }) => {
  return {
    url: `/api/Charts/annual-charts/${id}?returnData=${returnData}&masterObjectId=${masterObjectId}`
  };
};

export const GET_EXPOSURE_ASSET_CLASS_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/exposure-asset-class/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_STRATEGY_ATTRIBUTION_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/strategy-attribution/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_PORTFOLIO_MANAGERS_TABLE_DATA = ({ id, masterObjectId, groupBy, filters }) => {
  if (filters) {
    return {
      url: `/api/tables/portfolio-managers/${id}?groupBy=${groupBy}&masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/tables/portfolio-managers/${id}?groupBy=${groupBy}&masterObjectId=${masterObjectId}`
  };
};

export const GET_COMPARATIVE_STATS_TABLE_DATA = ({ id, masterObjectId, filters }) => {
  if(filters) {
    return {
      url: `/api/tables/comparative-stats/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/tables/comparative-stats/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_COMPARATIVE_STATS_LONG_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Tables/comparative-stats-long-performance/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_COMPARATIVE_STATS_SHORT_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Tables/comparative-stats-short-performance/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_YEAR_PERFORMANCE_EXPOSURE = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/charts/year-performance-exposure/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/charts/year-performance-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_YEAR_PERFORMANCE_EXPOSURE_STDV = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/Charts/year-performance-stdv-exposure/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/Charts/year-performance-stdv-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_EQUITY_EXPOSURE = ({ id, masterObjectId, filters }) => {
  if (filters) {
    return {
      url: `/api/Charts/equity-exposure/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/Charts/equity-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_FACTOR_RESPONSE = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/factor-response/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_INDEX_CORRELATION = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/rolling-comparison/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_DISTRIBUTION_MONTHLY_RETURNS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/distribution-monthly-returns/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_ROLLING_PROFITABLE = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/rolling-profitable/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_DRAWDOWN_HISTORY = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/drawdown-history-chart/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_CANNED_DASHBOARD_LIST = ({ masterObjectId }) => {
  return {
    url: `/api/Dashboards/canned/list/${masterObjectId}`
  };
};

export const GET_CANNED_DASHBOARDS = () => {
  return {
    url: `/api/Dashboards/canned`
  };
};

export const UPDATE_CANNED_DASHBOARD_SET = ({
  newDashboardId,
  firstOrdinal,
  secondOrdinal,
  masterObjectId,
  objectTypeDetailId,
  objectType,
  name
}) => {
  return {
    url: '/api/Dashboards/object-dashboard-set',
    method: 'put',
    data: {
      newDashboardId,
      firstOrdinal,
      secondOrdinal,
      masterObjectId,
      objectTypeDetailId,
      objectType,
      name
    }
  };
};

export const CREATE_USER_DASHBOARD = ({ username, password }) => {
  return {
    url: '/api​/Dashboards​/create',
    method: 'post',
    data: {
      username,
      password
    }
  };
};

export const PUT_TABLE_BENCHMARKS = ({ id, data }) => {
  return {
    url: `/api/tables/benchmarks/${id}`,
    method: 'put',
    data: {
      data
    }
  };
};

export const GET_STATISTIC_TYPES = () => {
  return {
    url: `/api/lookups/statistic-types`
  };
};

export const GET_AVAILABLE_PORTFOLIOS = () => {
  return {
    url: `/api/Objects?type=1`
  };
};

export const GET_AVAILABLE_PEER_GROUPS = () => {
  return {
    url: `/api/Objects?type=2`
  };
};

export const GET_AVAILABLE_INSTRUMENTS = () => {
  return {
    url: `/api/Objects?type=5`
  };
};

export const GET_AVAILABLE_DASHBOARDS_SHARED_WITH_ME = () => {
  return {
    url: `/api/dashboards/shared-with-me`
  };
};

export const SHARE_DASHBOARDS_TO_USER = ({ dashboardId, userIds }) => {
  return {
    url: '/api/Dashboards/share',
    method: 'post',
    data: {
      dashboardId,
      userIds
    }
  };
};

export const GET_AVAILABLE_USERS_TO_SHARE_DASHBOARDS_WITH = () => {
  return {
    url: `/api/Lookups/share-with`
  };
};

export const GET_AVAILABLE_HOLDINGS = () => {
  return {
    url: `/api/Objects?type=3`
  };
};

export const GET_TIME_SERIES = () => {
  return {
    url: `/api/lookups/time-series`
  };
};

export const GET_ROLLING_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId, filters }) => {
  if(filters) {
    return {
      url: `/api/tables/monthly-values/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }
  return {
    url: `/api/tables/monthly-values/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_MONTHLY_LONG_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Tables/monthly-values-long-performance/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_MONTHLY_SHORT_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Tables/monthly-values-short-performance/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_HOLDING_DETAILS_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/tables/holding-details/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_LONG_SHORT_ATTRIBUTION_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/long-short-attribution/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_HOLDING_LONG_SHORT_EXPOSURE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-long-short-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_HOLDING_SHORT_ATTRIBUTION_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-short-attribution-with-benchmarks/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_HOLDING_LONG_ATTRIBUTION_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-long-attribution-with-benchmarks/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_HOLDING_EXPOSURE_MARKET_CAP_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-exposure-market-cap/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_HOLDING_GEO_EXPOSURE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-geo-exposure/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_HOLDING_SECTOR_EXPOSURE_DATA = ({
  id,
  masterObjectId,
  returnData = 'LongShort'
}) => {
  return {
    url: `/api/Charts/holding-exposure-sector/${id}?masterObjectId=${masterObjectId}&returnData=${returnData}`
  };
};

export const GET_HOLDING_COMPANY_OVERVIEW_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-company-subs-reds-gain-loss/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_PORTFOLIO_STRATEGY_RISK_DATA = ({ id, masterObjectId, yearsBack = 1 }) => {
  return {
    url: `/api/Charts/portfolio-strategy-risk/${id}?masterObjectId=${masterObjectId}&yearsBack=${yearsBack}`
  };
};

export const GET_PORTFOLIO_FUND_RISK_DATA = ({ id, masterObjectId, yearsBack = 1 }) => {
  return {
    url: `/api/Charts/portfolio-fund-risk/${id}?masterObjectId=${masterObjectId}&yearsBack=${yearsBack}`
  };
};
export const EXAMPLE_DATA_FETCH = ({ fetchUrl }) => {
  return {
    url: fetchUrl
  };
};

export const LOGIN = ({ username, password }) => {
  return {
    url: '/api/users/login',
    method: 'post',
    data: {
      username,
      password
    }
  };
};

export const LOGOUT = () => {
  return {
    url: '/auth/logout',
    method: 'post'
  };
};

export const SYNC = () => {
  return {
    url: '/api/users/sync'
  };
};

export const GET_HEATMAP_SERIES = () => {
  return {
    url: '/api/Lookups/time-series-sets'
  };
};

export const GET_HEATMAP_DATES = () => {
  return {
    url: '/api/Dates/heatmap'
  };
};
export const GET_HEATMAP_DATA = ({
  timeSeriesSetId,
  date,
  groupBy,
  sortBy,
  showPortfolios,
  showIndexes,
  showProposedManagers
}) => {
  return {
    url: `/api/home/heatmap?date=${date}`,
    method: 'put',
    data: {
      timeSeriesSetId,
      sortBy,
      groupBy,
      showPortfolios,
      showIndexes,
      showProposedManagers
    }
  };
};

export const GET_NOTES = ({ masterObjectId, page, pageSize, searchText }) => {
  return {
    url: `/api/notes/series/${masterObjectId}?page=${page}&rows=${pageSize}&searchText=${searchText}`
  };
};

export const GET_NOTES_PREVIEW = ({ masterObjectId }) => {
  return {
    url: `/api/notes/series/${masterObjectId}/preview`
  };
};

export const GET_DOCUMENTS_ACCESS_BUTTONS = ({ masterObjectId }) => {
  return {
    url: `/api/documents/access-buttons/${masterObjectId}`
  };
};

export const GET_DOCUMENT = ({ id }) => {
  return {
    url: `/api/documents/${id}`
  };
};

export const SEARCH_TIME_SERIES = ({
  searchCriteria,
  seriesTypeId,
  seriesTypeDetailId,
  valueTypeId,
  periodicityId,
  parentObjectTypeId,
  isActive
}) => {
  return {
    url: `/api/lookups/time-series`,
    method: 'post',
    data: {
      searchCriteria,
      seriesTypeId: Number(seriesTypeId),
      seriesTypeDetailId: Number(seriesTypeDetailId),
      valueTypeId: Number(valueTypeId),
      periodicityId: Number(periodicityId),
      parentObjectTypeId: Number(parentObjectTypeId),
      isActive
    }
  };
};

export const GET_DIVERSIFICATION_RATIO_REALIZED = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/diversification-ratio-realized/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_DIVERSIFICATION_RATIO_BACKFILLED = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/diversification-ratio-backfilled/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_DIVERSIFICATION_BENEFIT_BACKFILLED = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/diversification-benefit-backfilled/${id}?masterObjectId=${masterObjectId}`
  };
};
export const GET_DIVERSIFICATION_BENEFIT_REALIZED = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/diversification-benefit-realized/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_HOLDING_ASSET_CLASS_ATTRIBUTION = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/holding-asset-class-attribution/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_PERFORMANCE_QUARTILES = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/performance-quartiles/${id}?masterObjectId=${masterObjectId}`
  };
};

// Custom widgets

export const GET_MANAGER_PERFORMANCE = ({ id, masterObjectId }) => {
  return {
    url: `/api/performance/manager/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_LOOKUP_TYPES = ({ type }) => {
  return {
    url: `/api/lookups?type=${type}`
  };
};

// Admin

export const ADMIN_GET_USER_LIST = ({ page, resultsPerPage = 20, search }) => {
  return {
    url: `/api/administration/Users?page=${page}&resultsPerPage=${resultsPerPage}&searchTerm=${search}`
  };
};

export const ADMIN_CREATE_USER = ({
  clientId,
  email,
  firstName,
  lastName,
  password,
  roleId,
  username,
  telephoneNumber
}) => {
  return {
    url: `/api/administration/Users/register`,
    method: 'post',
    data: {
      clientId,
      email,
      firstName,
      lastName,
      password,
      roleId,
      username,
      telephoneNumber
    }
  };
};

export const ADMIN_GET_USER_DETAILS = ({ id }) => {
  return {
    url: `/api/administration/Users/${id}`
  };
};

export const ADMIN_UPDATE_USER = ({
  username,
  roleId,
  role,
  emailAddress,
  password,
  clientId,
  firstName,
  lastName,
  telephoneNumber,
  heatmapSettings: {
    groupBy,
    showIndexes,
    showPortfolios,
    showProposedManagers,
    sortBy,
    timeSeriesSetId
  },
  id
}) => {
  return {
    url: `/api/administration/Users`,
    method: 'put',
    data: {
      username,
      roleId,
      role,
      emailAddress,
      password,
      clientId,
      firstName,
      lastName,
      telephoneNumber,
      heatmapSettings: {
        groupBy,
        showIndexes,
        showPortfolios,
        showProposedManagers,
        sortBy,
        timeSeriesSetId
      },
      id
    }
  };
};

export const ADMIN_GET_EXISTING_CLIENTS = () => {
  return {
    url: `/api/administration/Lookups/clients`
  };
};

export const ADMIN_DELETE_USER = ({ id }) => {
  return {
    url: `/api/administration/Users/delete/${id}`,
    method: 'post'
  };
};

export const ADMIN_TRANSFER_OBJECT_PERMISSIONS = ({ userId, acceptingUserId }) => {
  return {
    url: `/api/administration/Users/transfer/object-permissions`,
    method: 'post',
    data: {
      userId,
      acceptingUserId
    }
  };
};

export const GET_HOLDING_INVESTOR_PERFORMANCE_TABLE_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/tables/holding-investor-performance/${id}?masterObjectId=${masterObjectId}`
  };
};

export const ADMIN_GET_OVERLAY_LIST = ({ page, resultsPerPage = 20, search }) => {
  return {
    url: `/api/administration/overlays?page=${page}&resultsPerPage=${resultsPerPage}&searchTerm=${search}`
  };
};

export const ADMIN_GET_OVERLAY = ({ id }) => {
  return {
    url: `/api/administration/overlays/${id}`
  };
};

export const ADMIN_UPDATE_OVERLAY = ({
  id,
  name,
  widgetTitle,
  shouldInheritBenchmarks,
  caviatNotes,
  isSecondYAxisDisplayed,
  baseWidgetId,
  datasetTypeId,
  quartileChartType
}) => {
  return {
    url: `/api/administration/overlays`,
    method: 'put',
    data: {
      id,
      name,
      widgetTitle,
      shouldInheritBenchmarks,
      caviatNotes,
      isSecondYAxisDisplayed,
      baseWidgetId,
      datasetTypeId,
      quartileChartType
    }
  };
};

export const GET_BASE_WIDGETS = () => {
  return {
    url: `/api/Lookups/base-widgets`
  };
};

export const GET_OVERLAYS = ({ baseWidgetId, objectType = 0 }) => {
  return {
    url: `/api/Lookups/overlays?baseWidgetId=${baseWidgetId}&objectType=${objectType}`
  };
};

export const GET_DATASET_TYPES = () => {
  return {
    url: `/api/administration/Lookups/dataset-types`
  };
};

export const USER_CREATE_DASHBOARD = ({
  layoutId,
  name,
  description,
  benchmarks,
  masterObjectId,
  masterObjectTypeId,
  endReportingDate,
  dateRangeType,
  slots = 10,
  startReportingDate,
  timeSeriesSetId = null
}) => {
  return {
    url: `/api/Dashboards/create`,
    method: 'post',
    data: {
      layoutId,
      name,
      description,
      benchmarks,
      masterObjectId,
      masterObjectTypeId,
      endReportingDate,
      dateRangeType,
      slots,
      startReportingDate,
      timeSeriesSetId
    }
  };
};

export const USER_UPDATE_DASHBOARD = ({
  layoutId,
  name,
  description,
  benchmarks,
  masterObjectId,
  masterObjectTypeId,
  endReportingDate,
  dateRangeType,
  slots,
  startReportingDate,
  id,
  timeSeriesSetId = null
}) => {
  return {
    url: `/api/Dashboards/update`,
    method: 'PUT',
    data: {
      id,
      layoutId,
      name,
      description,
      benchmarks,
      masterObjectId,
      masterObjectTypeId,
      endReportingDate,
      dateRangeType,
      slots,
      startReportingDate,
      timeSeriesSetId
    }
  };
};

export const ADMIN_UPDATE_OVERLAY_CHART_SETTINGS = ({
  overlayId,
  baseWidgetId,
  xAxisFormatting,
  yAxisFormatting,
  y2AxisFormatting,
  xAxisPrefix,
  xAxisSuffix,
  yAxisPrefix,
  yAxisSuffix,
  y2AxisPrefix,
  y2AxisSuffix,
  xAxisName,
  yAxisName,
  y2AxisName
}) => {
  return {
    url: '/api/administration/Overlays/settings/chart',
    method: 'put',
    data: {
      overlayId,
      baseWidgetId,
      xAxisFormatting,
      yAxisFormatting,
      y2AxisFormatting,
      xAxisPrefix,
      xAxisSuffix,
      yAxisPrefix,
      yAxisSuffix,
      y2AxisPrefix,
      y2AxisSuffix,
      xAxisName,
      yAxisName,
      y2AxisName
    }
  };
};

export const USER_DELETE_DASHBOARD = ({ id }) => {
  return {
    url: `/api/Dashboards/delete/${id}`,
  method: 'delete'
  };
};

export const USER_DELETE_WIDGET = ({ id }) => {
  return {
    url: `/api/Widgets/delete/${id}`,
    method: 'POST'
  };
};

export const GET_USER_DASHBOARDS = () => {
  return {
    url: `/api/Dashboards`
  };
};

export const USER_CREATE_WIDGET = ({
  title,
  widgetOverlayId,
  startDate,
  endDate,
  masterObjectId,
  masterObjectTypeId,
  dashboardId,
  isDateDisplayed,
  isLegendDisplayed,
  isTitleDisplayed,
  isSecondYAxisDisplayed = false,
  isChartTooltipDisplayed,
  dateRangeTypeId,
  panelIndex,
  dateMatchType,
  shouldInheritBenchmarks,
  timeSeriesSetId = null,
  benchmarks,
  settings = {}
}) => {
  return {
    url: `/api/Widgets/create`,
    method: 'POST',
    data: {
      title,
      widgetOverlayId,
      startDate,
      endDate,
      masterObjectId,
      masterObjectTypeId,
      dashboardId,
      isDateDisplayed,
      isLegendDisplayed,
      isTitleDisplayed,
      isSecondYAxisDisplayed,
      isChartTooltipDisplayed,
      dateRangeTypeId,
      panelIndex,
      dateMatchType,
      shouldInheritBenchmarks,
      timeSeriesSetId,
      benchmarks,
      settings
    }
  };
};
export const USER_SAVE_DASHBOARD = ({
  benchmarks,
  dateRangeType,
  description,
  endReportingDate,
  id,
  masterObjectId,
  masterObjectTypeId,
  name,
  slots,
  startReportingDate
}) => {
  return {
    url: '/api/Dashboards/save',
    method: 'post',
    data: {
      benchmarks,
      dateRangeType,
      description,
      endReportingDate,
      id,
      masterObjectId,
      masterObjectTypeId,
      name,
      slots,
      startReportingDate
    }
  };
};

export const GET_TF_TOP_POSITIONS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-top-positions/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_NEW_POSITIONS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-new-positions/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_EXISTING_POSITIONS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-existing-positions/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_INCREASED_POSITIONS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-increased-positions/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_DECREASED_POSITIONS = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-decreased-positions/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_SECTOR_EXPOSURE_COLUMN = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-sector-column/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_MARKET_CAP_EXPOSURE = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-market-cap/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_LIQUIDITY_EXPOSURE = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-liquidity/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_OVERLAP_COUNT = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-overlap-count/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_OVERLAP_PERCENT = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-overlap-percent/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GET_TF_SECTOR_EXPOSURE_PIE = ({ id, masterObjectId }) => {
  return {
    url: `/api/Charts/tf-sector-pie/${id}?masterObjectId=${masterObjectId}`
  };
};

export const GLOBAL_SEARCH = ({ term }) => {
  return {
    url: `/api/search?criteria=${encodeURIComponent(term)}`
  };
};

export const GET_TABLE_B_WIDGET_DATA = ({ id, masterObjectId }) => {
  return {
    url: `/api/tables/correlation/${id}?masterObjectId=${masterObjectId}`
  };
};

export const USER_FORGOTTEN_PASSWORD = ({ emailAddress, baseUrl }) => {
  return {
    url: `/api/Users/forgotten-password`,
    method: 'POST',
    data: {
      emailAddress,
      baseUrl
    }
  };
};

export const RESET_PASSWORD = ({ newPassword, resetId }) => {
  return {
    url: `/api/Users/reset-password`,
    method: 'POST',
    data: {
      newPassword,
      resetId
    }
  };
};

export const GET_CLUSTER_DIAGRAM_WIDGET_DATA = ({ id, masterObjectId, filters }) => {
  if(filters) {
    return {
      url: `/api/tables/cluster-diagram/${id}?masterObjectId=${masterObjectId}&filters=${JSON.stringify(filters)}`
    };
  }

  return {
    url: `/api/tables/cluster-diagram/${id}?masterObjectId=${masterObjectId}`
  }
};

export const GET_SEARCH_FILTERS = () => {
  return {
    url: `/api/searchfilters`
  }
};

export const GET_SEARCH_FILTERS_TABLE_DATA = ({ startDate, endDate, TimeSerieSet, filters, searchScreenBoxes}) => {
  return {
    url: `/api/searchfilters/holdings-search-screen-table-data`,
    method: 'post',
    data: {
      startDate,
      endDate,
      TimeSerieSet: parseInt(TimeSerieSet, 10),
      filters,
      searchScreenBoxes
    }
  }
};
